import React from "react";
import classNames from "classnames";

import { compose } from "redux";
import withTranslations from "../../../../../../hocs/withTranslations";
import LandingTypography from "../../../../landingPage/pages/Homepage/components/LandingTypography";
import VotingButton from "../../VotingButton";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";
import arrowIcon from "../assets/arrow.svg";

const VotingInstructions = ({ translate }) => {
  const isDesktop = useIsDesktop();

  return (
    <LandingTypography>
      <p
        className={classNames("line-height-140 text-black opacity-80", {
          "text-sm mb-6": isDesktop,
          "text-xs mb-8": !isDesktop
        })}
      >
        {translate("voting-modal_description")}
      </p>
      <div
        className={classNames("bg-gray-5", {
          "p-6 rounded": isDesktop,
          "p-4 rounded-lg": !isDesktop
        })}
      >
        <div className={"flex flex-row gap-4 mb-6"}>
          <VotingButton />
          <img src={arrowIcon} alt={""} width={21} className={"shrink-0"} />
          <VotingButton checked />
        </div>
        <div className={"bg-white p-4 rounded-lg"}>
          <h2 className={"line-height-140 text-sm text-black font-bold mb-2"}>
            {translate("voting-instructions_title")}
          </h2>
          <p
            className={"text-xs text-black-7 line-height-140 mb-1.5"}
            dangerouslySetInnerHTML={{
              __html: translate("voting-instructions_paragraph-1")
            }}
          />
          <p
            className={"text-xs text-black-7 line-height-140 mb-0"}
            dangerouslySetInnerHTML={{
              __html: translate("voting-instructions_paragraph-2")
            }}
          />
        </div>
      </div>
    </LandingTypography>
  );
};

export default compose(withTranslations)(VotingInstructions);
